import { htmlToSmsText } from '@numeo/types-main-web-app'
import { Pencil, Trash2 } from 'lucide-react'
import { Badge, Switch } from '@/components/ds2'
import { BoxTruckMailingDto } from '@numeo/types-main-web-app'
import { DAY_LABELS } from '../utils/mailing'

/** The existing-mailings cards under the form: name + Active/Paused badge, schedule summary, message
 *  preview, and the enable switch / edit / delete actions. Presentational. */
export const MailingList = ({
    mailings,
    onToggleEnabled,
    onEdit,
    onDelete,
}: {
    mailings: BoxTruckMailingDto[]
    onToggleEnabled: (m: BoxTruckMailingDto) => void
    onEdit: (m: BoxTruckMailingDto) => void
    onDelete: (m: BoxTruckMailingDto) => void
}) => {
    if (mailings.length === 0) return <p className="px-1 text-xs text-foreground-muted">No mailings yet — schedule the first one above.</p>
    return (
        <div className="space-y-2">
            {mailings.map((m) => (
                <div key={m._id} className="flex items-start justify-between gap-3 rounded-2xl bg-surface p-4 shadow-surface">
                    <div className="min-w-0">
                        <div className="flex items-center gap-2">
                            <span className="text-sm font-semibold">{m.name}</span>
                            <Badge variant="soft" type={m.enabled ? 'success' : 'default'} label={m.enabled ? 'Active' : 'Paused'} />
                            <Badge variant="soft" type={m.service === 'sms' ? 'accent' : 'default'} label={m.service === 'sms' ? 'SMS' : 'Telegram'} />
                        </div>
                        <div className="mt-0.5 text-xs text-foreground-muted">
                            {m.timeEST} EST · {m.days.length === 7 ? 'Every day' : m.days.map((d) => DAY_LABELS[d]).join(', ')} · {m.driverAccountIds.length}{' '}
                            driver{m.driverAccountIds.length === 1 ? '' : 's'}
                            {m.lastSentDateEST ? ` · last sent ${m.lastSentDateEST}` : ''}
                        </div>
                        <p className="mt-1 line-clamp-2 text-xs text-foreground-muted/80">{htmlToSmsText(m.message)}</p>
                    </div>
                    <div className="flex shrink-0 items-center gap-1.5">
                        <Switch checked={m.enabled} onChange={() => onToggleEnabled(m)} />
                        <button
                            type="button"
                            onClick={() => onEdit(m)}
                            title="Edit"
                            className="rounded-lg p-1.5 text-foreground-muted transition-colors hover:bg-default hover:text-foreground"
                        >
                            <Pencil size={15} />
                        </button>
                        <button
                            type="button"
                            onClick={() => onDelete(m)}
                            title="Delete"
                            className="rounded-lg p-1.5 text-foreground-muted transition-colors hover:bg-danger-soft hover:text-danger"
                        >
                            <Trash2 size={15} />
                        </button>
                    </div>
                </div>
            ))}
        </div>
    )
}
